export default __webpack_public_path__ + "static/media/background1.ae5507f8.jpg";